import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import axios from 'axios';
import { i18n } from '../../translate/i18n';
import { fetchEquipmentModelsService, fetchEquipmentModelsByIdService } from '../../services/equipmentModes'

let CancelToken = axios.CancelToken;
let fetchEquipmentModel_cancel;
let fetchEquipmentModelById_cancel;
let fetchEquipmentModelExport_cancel;

export const fetchEquipmentModelsReportsSuccess = (equipmentModels) => ({
  type: actionTypes.REPORTS_FETCH_EQUIPMENT_MODELS_SUCESS,
  equipmentModels,
});

export const fetchEquipmentModelsReportsFail = (error) => ({
  type: actionTypes.REPORTS_FETCH_EQUIPMENT_MODELS_FAIL,
  error,
});

export const fetchEquipmentModelsReportsStart = () =>({
  type: actionTypes.REPORTS_FETCH_EQUIPMENT_MODELS_START
});


export const fetchEquipmentModelByIdReportsSuccess = (equipmentModel) => ({
  type: actionTypes.REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_SUCCESS,
  equipmentModel,
});

export const fetchEquipmentModelByIdReportsFail = (error) => ({
  type: actionTypes.REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_FAIL,
  error,
});

export const fetchEquipmentModelByIdReportsStart = () => ({
  type: actionTypes.REPORTS_FETCH_EQUIPMENT_MODEL_BY_ID_START,
});

export const fetchEquipmentModelsReports = (search) => {
  fetchEquipmentModel_cancel && fetchEquipmentModel_cancel()

  return dispatch => {
    dispatch(fetchEquipmentModelsReportsStart());
    fetchEquipmentModelsService(1, 10, search)
      .then(res => {
        dispatch(fetchEquipmentModelsReportsSuccess(res.data));
      })
      .catch(err => {
        dispatch(fetchEquipmentModelsReportsFail(err));
      });
  };
};

export const fetchEquipmentModelByIdReports = (id) => {
  return dispatch => {
    dispatch(fetchEquipmentModelByIdReportsStart());
    fetchEquipmentModelsByIdService(id)
      .then(res => {
        dispatch(fetchEquipmentModelByIdReportsSuccess(res.data));
      })
      .catch(err => {
        dispatch(fetchEquipmentModelByIdReportsFail(err));
      });
  };
};

export const clearSelectedEquipmentModelReports = () => ({
  type: actionTypes.REPORTS_CLEAR_SELECTED_EQUIPMENT_MODEL,
});
